import { render } from "./svg-rebate.vue?vue&type=template&id=6396189e"
import script from "./svg-rebate.vue?vue&type=script&lang=ts"
export * from "./svg-rebate.vue?vue&type=script&lang=ts"
script.render = render

export default script